import Editor from "./Editor";
import Admin from "./Admin";
import Assignment from "./Assignment";

export default class Invite {
    private readonly _id: string;
    private readonly _assignment: Assignment;
    private readonly _status: string;
    private readonly _editor: Editor|null;
    private readonly _invitedBy: Admin|null;
    private readonly _queuedAt: Date;
    private readonly _invitedAt: Date;
    private readonly _deadline: Date;
    private readonly _decidedAt: Date|null;
    private readonly _disconnectedAt: Date|null;
    private readonly _timer: number;
    private readonly _timerUpdatedAt: Date|null;
    private readonly _links: object;
    private readonly _onHold: boolean;
    private readonly _rate: string|null;
    constructor({
        id,
        status,
        editor,
        queuedAt,
        invitedAt,
        decidedAt,
        disconnectedAt,
        deadline,
        timer,
        timerUpdatedAt,
        invitedBy,
        links,
        onHold,
        rate,
    }, assignment) {
        this._id = id;
        this._assignment = assignment;
        this._status = status;
        // @ts-ignore
        this._editor = editor ? new Editor(editor, this._assignment.language) : null;
        this._invitedBy = invitedBy ? new Admin(invitedBy) : null;
        this._queuedAt = new Date(queuedAt);
        this._invitedAt = new Date(invitedAt);
        this._deadline = new Date(deadline);
        this._decidedAt = decidedAt ? new Date(decidedAt) : null;
        this._disconnectedAt = disconnectedAt ? new Date(disconnectedAt) : null;
        this._timer = timer; //in minutes
        this._timerUpdatedAt = timerUpdatedAt ? new Date(timerUpdatedAt) : null;
        this._links = links;
        this._onHold = onHold;
        this._rate = rate;
    }

    get id(): string {
        return this._id;
    }

    get assignment(): Assignment {
        return this._assignment;
    }

    get status(): string {
        return this._status;
    }

    get isWaitingForReply(): boolean {
        return this._status === 'waiting-for-reply';
    }

    get isAccepted(): boolean {
        return this._status === 'accepted';
    }

    get isQueued(): boolean {
        return this._status === 'queued';
    }

    get editor(): Editor|null {
        return this._editor;
    }

    get invitedBy(): Admin|null {
        return this._invitedBy;
    }

    get invitedAt(): Date {
        return this._invitedAt;
    }

    get queuedAt(): Date {
        return this._queuedAt;
    }

    get deadline(): Date {
        return this._deadline;
    }

    get decidedAt(): Date|null {
        return this._decidedAt;
    }

    get secondsAgo() {
        return Math.round((new Date().getTime() - this._invitedAt.getTime()) / 1000);
    }

    get hasTimer() {
        if (!this.isQueued && !this.isWaitingForReply) {
            return false;
        }
        return !!this._timer;
    }

    get timerSeconds() {
        if (!this.hasTimer) {
            return null;
        }
        if (this.isQueued) {
            return this._timer * 60;
        }
        // @ts-ignore
        return Math.round(this._timerUpdatedAt.getTime() / 1000 - new Date().getTime() / 1000 + this._timer * 60);
    }

    get waitedForSeconds() {
        if (this.isQueued) {
            return null;
        }

        if (this.isWaitingForReply) {
            return Math.round(new Date().getTime() / 1000 - this._invitedAt.getTime() / 1000);
        }

        if (this._decidedAt) {
            return Math.round(this._decidedAt.getTime() / 1000 - this._invitedAt.getTime() / 1000);
        }

        if (this._disconnectedAt) {
            return Math.round(this._disconnectedAt.getTime() / 1000 - this._invitedAt.getTime() / 1000);
        }

        return null;
    }

    get onHold(): boolean {
        return this._onHold;
    }

    get rate(): string|null {
        return this._rate;
    }

    get links(): object {
        return this._links;
    }

    get canBePutOnHold(): boolean {
        return this.isWaitingForReply || this.isQueued;
    }
}
